module.exports = __webpack_public_path__ + "static/media/under_developement.398d413a.png";